module.exports = __webpack_public_path__ + "static/media/6C.01388d51.svg";